import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { GlobalNavProvider } from '../../../../state';
import { GlobalNavProps } from '../../../types';
import ResultsPageSearchBar from './ResultsPageSearchBar';
import styles from './SearchBar.module.scss';

const SearchBarStandalone: React.FC<GlobalNavProps> = ({
    searchBar,
    logo,
    navigation,
    user,
    env,
}) => {
    return (
        <GlobalNavProvider
            positionSticky={{ desktop: false, mobile: false }}
            searchBar={searchBar}
            logo={logo}
            user={user}
            env={env}
            navigation={navigation}
        >
            <div className={styles.searchBarStandalone}>
                <nav
                    aria-label={gettext('Main Navigation').toString()}
                    data-testid="standalone-nav"
                >
                    <ResultsPageSearchBar />
                </nav>
            </div>
        </GlobalNavProvider>
    );
};

export default SearchBarStandalone;
